import styled from 'styled-components';

export const PaymentOption = styled.button<{ active?: boolean; color: string }>`
  flex: 1;
  min-height: 80px;
  display: flex;
  flex-direction: column;
  align-items: center;
  justify-content: center;
  gap: 8px;
  border: ${(props) => (props.active ? `2px solid ${props.color}` : '2px solid transparent')};
  border-radius: 10px;
  background: ${(props) => (props.active ? '#fff' : 'transparent')};
  color: ${(props) => (props.active ? props.color : '#6b7280')};
  cursor: pointer;
  transition: all 0.2s ease;
  padding: 12px 8px;
  box-shadow: ${(props) =>
    props.active ? '0 2px 10px rgba(0, 0, 0, 0.08)' : 'none'};
  position: relative;
  z-index: 1;
  font-weight: ${(props) => (props.active ? '600' : '500')};

  &:hover {
    background: ${(props) =>
      props.active ? '#fff' : 'rgba(255, 255, 255, 0.6)'};
  }

  span {
    font-size: 13px;
    font-weight: inherit;
    text-align: center;
  }

  svg {
    opacity: ${(props) => (props.active ? '1' : '0.5')};
    transition: all 0.2s;
  }

  @media (max-width: 640px) {
    min-height: 64px;
    flex-direction: row;
    justify-content: flex-start;
    gap: 12px;
    padding: 12px 16px;

    span {
      font-size: 13px;
    }
  }
`;

export const PaymentOptions = styled.div`
  display: flex;
  gap: 0;
  margin-bottom: 16px;
  background: #F4F5F7;
  padding: 4px;
  border-radius: 14px;
  position: relative;

  @media (max-width: 640px) {
    flex-direction: column;
    gap: 4px;
  }
`;

export const IconWrapper = styled.div<{ size?: string }>`
  width: ${(props) => props.size || '24px'};
  height: ${(props) => props.size || '24px'};
  display: flex;
  align-items: center;
  justify-content: center;

  svg {
    color: currentColor;
  }
`;
